// extracted by mini-css-extract-plugin
export default {"privacyPopup":"privacyPopup___d61eec437fc648516d68","content":"content___cfae54e81e2d68759a54"};